import { 
    CreateHotelDto, 
    DeleteHotelDto,
    EditHotelDto,
    GetHotelDto, 
    HotelApiFp,
    HotelControllerGet200Response,
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseHotelModel = HotelControllerGet200Response;
export type GetHotelModel = GetHotelDto;
export type MutateResponseHotelModel = MessageResponseDto;
export type CreateHotelModel = CreateHotelDto;
export type UpdateHotelModel = EditHotelDto;
export type DeleteHotelModel = DeleteHotelDto;

export const apiHotelFp = HotelApiFp(apiConfig);
export const getHotelController = apiHotelFp.hotelControllerGet;
export const createHotelController = apiHotelFp.hotelControllerCreate;
export const updateHotelController = apiHotelFp.hotelControllerEdit;
export const deleteHotelController = apiHotelFp.hotelControllerDelete;

export const QueryKeyHotel = QueryKey.Hotel;